/**
 * AC-1700: Single source of truth for the product/assistant brand name.
 *
 * The in-app copilot (the right-side chat panel) is branded as the product
 * itself — "Agent Commander" — rather than the generic "AI Assistant". Import
 * ASSISTANT_NAME everywhere the copilot is named so the label can never drift
 * across the panel header, sidebar launcher, bootcamp pages, and route titles.
 *
 * NOTE: this is the PRODUCT COPILOT name only. The in-run agent step chat
 * (workflow/MessageList.tsx, workflow/ChatInterface.tsx) is a distinct,
 * user-configured agent surface and intentionally does NOT use this name.
 */
export const ASSISTANT_NAME = 'Agent Commander';

/** The product name, kept alongside the assistant name for symmetry. */
export const PRODUCT_NAME = 'Agent Commander';
